import Footer from '@components/footer/SPAFooter'
import Header from '@components/header/Header'
import { Box } from '@ds/components'
import { PropsWithChildren } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

type LayoutProps = PropsWithChildren<{
    differentTopPadding?: number
    maximumWidth?: boolean
    isSEO?: boolean
}>

const Layout: React.FC<LayoutProps> = ({ children, differentTopPadding = 0, maximumWidth = false, isSEO = false }) => {
    return (
        <>
            <Header />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    pt: differentTopPadding,
                    flexBasis: 70,
                    width: '100%',
                    maxWidth: maximumWidth ? '100%' : '1020px',
                    minHeight: '75vh',
                    alignSelf: 'center',
                    flexGrow: 1,
                    margin: '0 auto',
                    backgroundColor: isSEO ? '#f5f6f7' : '#ffffff',
                    px: 2,
                }}
            >
                <ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
                    {children}
                </ErrorBoundary>
            </Box>
            <Footer />
        </>
    )
}
export default Layout
